import { render, staticRenderFns } from "./MenuDropdownItems.vue?vue&type=template&id=c5ad3494&scoped=true&"
import script from "./MenuDropdownItems.vue?vue&type=script&lang=js&"
export * from "./MenuDropdownItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5ad3494",
  null
  
)

export default component.exports